import RoomContextProviders from '@contexts/RoomContextProviders';
import useCurrentEventInfo from '@contexts/useCurrentEventInfo';
import { LiveKitRoom } from '@livekit/components-react';
import { useGetRoom, useLeaveRoom } from '@queries/rooms';
import { LIVEKIT_URL } from '@sunrise-ui/api-client';
import { withAuthGate } from '@sunrise-ui/composites';
import { Loader, useAuthStore } from '@sunrise-ui/primitives';
import RoomView from '@templates/RoomView';
import React from 'react';
import { StyleSheet } from 'react-native';

function EventScreen() {
  const { roomToken, currentRoomId } = useCurrentEventInfo();
  const { currentUserId } = useAuthStore();
  const { data: room, isLoading } = useGetRoom(currentRoomId);
  const isHost = room?.user_id === currentUserId;
  const { mutate: leaveRoom } = useLeaveRoom();

  if (isLoading) return <Loader />;

  return (
    <LiveKitRoom
      serverUrl={LIVEKIT_URL}
      token={roomToken}
      connect={true}
      audio={isHost}
      video={isHost}
      style={styles.flexRowContainer}
      onDisconnected={() => {
        leaveRoom();
      }}
    >
      <RoomContextProviders>
        <RoomView />
      </RoomContextProviders>
    </LiveKitRoom>
  );
}

const styles = StyleSheet.create({
  flexRowContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    height: '100%',
  },
});

export default withAuthGate(EventScreen);
